import { render, staticRenderFns } from "./veSbzcZcAssetShow.vue?vue&type=template&id=0f79dfe0&scoped=true"
import script from "./veSbzcZcAssetShow.vue?vue&type=script&lang=js"
export * from "./veSbzcZcAssetShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79dfe0",
  null
  
)

export default component.exports